module.exports = __webpack_public_path__ + "static/media/ciara4.25be6de0.jpg";